export default "__VITE_ASSET__x0xLIbwF__"